import { useQueryClient } from '@tanstack/react-query'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { type FillOrgRef, invalidateFillApplication } from '@/models/fillApplication'
import { FmcsaStep } from './FmcsaStep'

interface FmcsaViewProps {
  orgId: string
  initialDot: string
  duplicateOf: FillOrgRef | null
}

export function FmcsaView({ orgId, initialDot, duplicateOf }: FmcsaViewProps) {
  const queryClient = useQueryClient()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Find the carrier</CardTitle>
        <CardDescription>
          Look the DOT up on FMCSA. Nothing is saved until you pick the carrier.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <FmcsaStep
          orgId={orgId}
          initialDot={initialDot}
          duplicateOf={duplicateOf}
          onSaved={() => void invalidateFillApplication(queryClient, orgId)}
        />
      </CardContent>
    </Card>
  )
}
